import { render, staticRenderFns } from "./GroupManger.vue?vue&type=template&id=9163e1c0&scoped=true&"
import script from "./GroupManger.vue?vue&type=script&lang=js&"
export * from "./GroupManger.vue?vue&type=script&lang=js&"
import style0 from "./GroupManger.vue?vue&type=style&index=0&id=9163e1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9163e1c0",
  null
  
)

export default component.exports